/**
 * Query params for GET /brands — eager-load relations for table & forms.
 * Adjust names if your API uses snake_case only (e.g. payment_account, brand_category).
 */
export const BRAND_RELATIONS = [
  'brandCategory',
  'paymentAccounts',
];

export const buildBrandRelationParams = () =>
  BRAND_RELATIONS.reduce((acc, rel, i) => {
    acc[`relations[${i}]`] = rel;
    return acc;
  }, {});
